<template>
    <div>
        <ProductsNav />
        <main class="col-lg-10 col-md-9 col-sm-9 left_gutter fill">
            <h1>Custom Curbs</h1>

            <h4>We pride ourselves in being able to create solutions for your most challenging projects</h4>

            <h3>Vibration Isolation</h3>
            <ul class='list_content'>
                <li>Isolation Curb</li>
                <li>Isolation Rail</li>
                <li>Seismic Load Versions (Conforming Curbs)</li>
                <li>Wind Load Versions</li>
            </ul>

            <h3>Straight Curbs</h3>
            <ul class='list_content'>
                <li>Knock Down Curb</li>
                <li>Welded Curb</li>
                <li>Horizontal Discharge Curb</li>
                <li>Exhaust Fan Curb</li>
                <li>Seismic Versions (Conforming Curbs)</li>
                <li>Wind Load Versions</li>
            </ul>

            <h3>Applied Curbs</h3>
            <ul class='list_content'>
                <li>Horizontal Discharge</li>
            </ul>

            <h3>Pitched Curbs</h3>
            <ul class='list_content'>
                <li>Welded Curb</li>
                <li>Metal Building Curb</li>
                <li>Exhaust Fan Curb</li>
                <li>Seismic Load Versions (Conforming Curbs)</li>
                <li>Wind Load Versions</li>
            </ul>

            <h3>Custom / Misc Fabrication</h3>
            <ul class='list_content'>
                <li>Equipment Rail</li>
                <li>Burglar Bars</li>
                <li>S Clips / Hold Downs, Tie Downs w/Turnbuckle</li>
            </ul>
        </main>
    </div>
</template>

<script>
import ProductsNav from '@/components/content/ProductsNav.vue'
export default {
    name: "CustomCurbs",
    components: {
        ProductsNav,
    },
    created() {
        this.$appStore.setTitle(['Custom Curb Adapters']);
    },
}
</script>

<style scoped>

</style>